import { numberToPrettyString } from '@cian/utils';

export function formatPrice(price: number | undefined, isRent: boolean): string {
  if (!price) {
    return '';
  }

  return `${numberToPrettyString(price)} ₽${isRent ? '/мес.' : ''}`;
}
